import PropTypes from 'prop-types';
import DatasourceBaseOauthNew from "../Datasources/DatasourceBaseOauthNew.jsx";

const DatasourceAdminPulse = (props) => {

    const ClientId = "cloudcti.client"
    const Scope = "offline_access relations.read users.read interactions.write"
    const RedirectUrl = "https://auth.cloudcti.nl/webapi/oauth2"
    const AuthUrl = "https://login.adminpulse.be/connect/authorize?scope=" + Scope + "&client_id=" + ClientId + "&response_type=code&redirect_uri=" + RedirectUrl

    return <DatasourceBaseOauthNew SecurityToken={props.SecurityToken} DatasourceData={props.DatasourceData} IntegrationSettings={props.IntegrationSettings} AuthUrl={AuthUrl} CrmServerTokenController="/api/adminpulse/tokens" OnSetReady={props.OnSetReady}/>
}

DatasourceAdminPulse.propTypes = {
    SecurityToken: PropTypes.string,
    DatasourceData: PropTypes.object,
    IntegrationSettings: PropTypes.object,
    OnSetReady: PropTypes.func
}   

export default DatasourceAdminPulse